import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const editProphetPage: prophetTypes.EditProphetPage = (data) => {
  return axios.patch(`/prophet/pages`, data);
};

type EditProphetPageOptions = {
  onSuccess: () => void;
  config?: MutationConfig<typeof editProphetPage>;
};

const AI_ID_REQUIRED_ERROR = 'AI ID is required to save page while AI refuses is enabled';
const AI_ID_REQUIRED_MESSAGE_RU =
  'Для сохранения страницы с включенными возражениями ИИ необходимо заполнить поле AI ID';

export function useEditProphetPage({ config = {}, onSuccess }: EditProphetPageOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      toasts.loadingToast.success('edit-prophet-page', 'Страница сохранена');
      queryClient.invalidateQueries(['prophet-pages']);
      queryClient.invalidateQueries(['prophet-page']);
      queryClient.invalidateQueries(['prophet-page-audit']);
      onSuccess();
    },
    onError: (error: AxiosError<{ error?: string }>) => {
      const serverMessage = error.response?.data?.error;
      const uiMessage =
        serverMessage === AI_ID_REQUIRED_ERROR ? AI_ID_REQUIRED_MESSAGE_RU : serverMessage;
      toasts.loadingToast.error('edit-prophet-page', uiMessage);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-prophet-page', 'Сохраняем страницу...');
      config.onMutate?.(...args);
    },
    mutationFn: editProphetPage,
  });
}
